// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/.store/css-loader@3.6.0/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".space_group_item[data-v-62c4d9f0]{margin-left:28%}.el-collapse[data-v-62c4d9f0]{border-bottom:none}.sub_item .answer-sub-group[data-v-62c4d9f0]{text-indent:2%;background-color:#e4e5e7}.sub_item .answer-sub-group .add_groupTopic[data-v-62c4d9f0]{right:50px}", ""]);
// Exports
module.exports = exports;
